<template>
  <div class="common_page_container" :key="type" v-responsive-layout="'responsive_page'">
    <ul v-infinite-scroll="getDocList" :infinite-scroll-disabled="disabledScroll" class="infinite_list">
      <banner :data="bannerList" @event="handleBannerEvent" />
      <div class="content_area">
        <div class="tag_area" v-if="tagList.length > 1">
          <el-tag v-for="(item, index) in tagList" :key="index" size="large"
                  class="tag_item" :type="handleActiveTag(item)"
                  @click="handleClickTag(item)">{{ item.name }}</el-tag>
        </div>
        <div class="search_area">
          <el-input size="default" type="text" clearable class="search_input"
                    v-model="searchValue" @keyup.enter.native="getDocList(true)">
            <template #prepend>
              <el-select v-model="searchArea" style="width: 100px">
                <el-option :label="currColumn.name" value="curr" />
                <el-option label="本站" value="all" />
              </el-select>
            </template>
            <template #append>
              <el-button :icon="search" @click="getDocList(true)" />
            </template>
          </el-input>
        </div>
        <div class="doc_area">
          <component :is="currColumn.list_style" :data="dataList"
                     :show-column="searchArea === 'all'"
                     @event="handleListEvent" />
        </div>
      </div>
    </ul>
    <bottom-column @event="handleBottomColumnEvent" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Search } from '@element-plus/icons-vue';
import { markRaw, defineAsyncComponent } from 'vue'

export default {
  name: "CommonPage",
  components: {
    Banner: defineAsyncComponent(() => import('@components/banner')),
    List: defineAsyncComponent(() => import('@/projects/common/views/common/components/ListItem')),
    Card: defineAsyncComponent(() => import('@/projects/common/views/common/components/CardListItem')),
    BottomColumn: defineAsyncComponent(() => import('@/projects/common/views/common/components/BottomColumn')),
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      bannerList: [],
      pageIndex: 1,
      pageSize: window.configs.PAGE_SIZE,
      dataList: [],
      disabledScroll: false,
      requestedPageList: [],
      searchValue: '',
      search: markRaw(Search),
      searchArea: 'curr',
    };
  },
  computed: {
    ...mapState([ 'setting', 'currColumn', 'columnList', 'tagList', 'activeTag' ]),
    bottomColumnList() {
      return this.columnList.filter(item => item.location === 'bottom');
    },
    titleName() {
      let title = this.setting.cms_website_name;
      if (this.isNotEmpty(this.currColumn.name)) {
        title = this.currColumn.name;
      }
      return title;
    },
  },
  watch: {
    $route: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true,
    },
  },
  // mounted() {
  //   this.test();
  // },
  methods: {
    async init() {
      this.initBanner();
      if (this.isNotEmpty(this.tagList) && this.isEmpty(this.activeTag.sid)) {
        this.storeCommit('SET_ACTIVE_TAG', $.extend({}, this.tagList[0]));
      }
      this.pageIndex = 1;
      this.pageSize = window.configs.PAGE_SIZE;
      if (this.currColumn.list_style === 'card') {
        this.pageSize = 15;
      }
      this.dataList = [];
      this.requestedPageList = [];
      this.disabledScroll = false;
      this.searchValue = '';
      this.searchArea = 'curr';
    },
    initBanner() {
      this.bannerList = [];
      if (this.isNotEmpty(this.currColumn.ad_url_json)) {
        let list = JSON.parse(this.currColumn.ad_url_json);
        if (this.isNotEmptyList(list)) {
          list.forEach(item => {
            if (this.isNotEmpty(item.icon_url)) {
              item.icon_path = this.getFileUrl(item.icon_url);
            }
            if (this.isNotEmpty(item.main_pic_url)) {
              item.main_pic_path = this.getFileUrl(item.main_pic_url);
            }
          });
        }
        this.bannerList = list;
      }
    },
	  handleBannerEvent(event) {
			if (event.type === 'detail') {
				this.handleOpenDetail(event.data);
			}
	  },
    handleActiveTag(item) {
      if (this.isNotEmpty(this.activeTag.sid)) {
        return this.activeTag.sid === item.sid ? '' : 'info';
      }
      return '';
    },
    handleClickTag(item) {
      this.storeCommit('SET_ACTIVE_TAG', item);
      this.pageIndex = 1;
      this.dataList = [];
      this.requestedPageList = [];
      this.disabledScroll = false;
    },
    async getDocList(search) {
      let _this = this;
      if (_this.isEmpty(_this.currColumn.sid)) {
        return;
      }
      if (search) {
        _this.requestedPageList = [];
        _this.pageIndex = 1;
        _this.dataList = [];
        _this.disabledScroll = false;
      }
      // 记录已请求的页码， 防止重复请求
      if (_this.requestedPageList.includes(_this.pageIndex)) {
        return;
      }
      _this.requestedPageList.push(_this.pageIndex);
      let queryData = {
        pageNo: _this.pageIndex,
        pageSize: _this.pageSize,
        state: 1,
        column_sid: _this.currColumn.sid,
      };
      if (_this.isNotEmpty(_this.activeTag.sid) && _this.activeTag.sid !== '-1') {
        queryData.tag_sid = _this.activeTag.sid;
      }
      if (_this.isNotEmpty(_this.searchValue)) {
        queryData.search_value = _this.searchValue;
      }
      if (_this.searchArea === 'all') {
        delete queryData.column_sid;
      }
      await _this.fetchData(_this.$api.API_GetCmsDocList, queryData).then(result => {
        let resData = result.data || [];
        if (_this.isNotEmptyList(resData)) {
          resData.forEach(item => {
            if (_this.isNotEmpty(item.icon_url)) {
              item.icon_path = _this.getFileUrl(item.icon_url);
            }
            if (_this.isNotEmpty(item.main_pic_url)) {
              item.main_pic_path = _this.getFileUrl(item.main_pic_url);
            }
          });
        }
        _this.dataList = [..._this.dataList, ...resData];
        _this.pageIndex = result.page.next;
        _this.disabledScroll = _this.pageIndex > result.page.pages;
      });
    },
    handleOpenDetail(item) {
      if (item.is_ex === 1) {
        if (this.isNotEmpty(item.ex_url)) {
          window.open(item.ex_url);
        }
        return;
      }
      this.$router.push({
        path: `/detail/${item.static_url}`,
      });
    },
    handleListEvent(event) {
      if (event.type === 'clickItem') {
        this.handleOpenDetail(event.data);
      }
    },
    handleBottomColumnEvent(event) {
      if (event.type === 'openBottomDetail') {
        this.handleOpenDetail(event.data);
      }
    },
      test(){
          const OSS = require('ali-oss');

          const client = new OSS({
              // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
              region: 'oss-cn-guangzhou',
              // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
              accessKeyId: 'STS.NTik8hshecArWpxCakQjwuNe9',
              accessKeySecret: 'Ff62yF8EoWWwdj6WckrnqrDiFjUuoegib81abVC4FywR',
              // 从STS服务获取的安全令牌（SecurityToken）。
              stsToken: 'CAIS9AF1q6Ft5B2yfSjIr5fcIILcnrdE1IOZVVbJp2E+XeVbmovO2zz2IHpOeXFsBOwbsfk/mm1W6vgSlqJIRoReREvCUcZr8szBI6lO/82T1fau5Jko1beHewHKeTOZsebWZ+LmNqC/Ht6md1HDkAJq3LL+bk/Mdle5MJqP+/UFB5ZtKWveVzddA8pMLQZPsdITMWCrVcygKRn3mGHdfiEK00he8TomsvzjmZPHskuP1AWll7cvyt6vcsT+Xa5FJ4xiVtq55utye5fa3TRYgxowr/0s0fQYpGua4YzNXQQPv0vWKYjO+9hoNxRla7MmCwiXASUXeRQSGoABZair7CoPnn3xbHIB0wWdlsS/MmQZ9cEabikt+UEu+8fEErltAUBas/U8vzxGUMN8ysqavGbsiYsyjsN70xOhVk1nAR23EcT78eFSZgX4wTsA5r4eG4BJpHur+sVuXHIp1N4S5ngqld8gVgxiNgfw5Q5ToIsc5jPidsCojJwBCcg=',
              // 填写Bucket名称。
              bucket: 'tsd-website',
          });

          let url;
// 填写Object完整路径。Object完整路径中不能包含Bucket名称。文件URL的有效时长默认为1800秒，即30分钟。
          url = client.signatureUrl('30cf51f206834eb8b42559e7710332cc.jpg');
          console.log(url);

// 设置URL的有效时长为3600，单位为秒。如果不设置有效时长，则默认值为1800。
//url = client.signatureUrl('exampleobject.txt', {expires: 3600});
//console.log(url);
      }
  },
}
</script>

<style scoped lang="scss">
.common_page_container {
  width: 100%;
  height: 100%;
  overflow: auto;

  .infinite_list {
    width: 100%;
    height: auto;

    .banner_area {
      width: 100%;
      height: 500px;

      :deep(.banner_image) {
        width: 100%;
        height: 100%;
      }
    }

    .content_area {
      width: 1000px;
      height: auto;
      margin: 10px auto;

      .tag_area {
        width: 100%;
        height: auto;
        text-align: left;
        margin-bottom: 10px;

        .tag_item {
          margin-right: 15px;
          border-radius: 20px;
          font-size: 14px;
          padding: 2px 14px;
          cursor: pointer;
        }
      }

      .search_area {
        width: 100%;
        margin-bottom: 10px;

        .search_input {
          :deep(.el-input-group__prepend) {
            background-color: #fff;

            .el-input__inner {
              text-align: center;
            }
          }
        }
      }

      .doc_area {
        width: 100%;
        height: auto;

        .infinite_list_item {
          list-style: none;

          .item_content {
            padding: 15px 10px 0;
	          cursor: pointer;

            &:hover {
              background-color: #fafafa;
            }

            .item_title {
              font-size: 18px;
              font-weight: 500;
              color: #222226;
              overflow: hidden;
              white-space: normal;
              word-break: break-word;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              line-height: 25px;
              margin-bottom: 10px;
              text-align: left;
              cursor: pointer;

              &:hover {
                text-decoration: underline;
              }
            }

            .item_desc {
              padding-bottom: 15px;
              border-bottom: 1px solid #f0f0f2;
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -webkit-box-orient: horizontal;
              -webkit-box-direction: reverse;
              -ms-flex-flow: row-reverse;
              flex-flow: row-reverse;

              .item_desc_content {
                flex: 1;
                display: flex;
                -webkit-box-orient: vertical;
                -webkit-box-direction: normal;
                -ms-flex-direction: column;
                flex-direction: column;
                -webkit-box-pack: justify;
                -ms-flex-pack: justify;
                justify-content: space-between;

                .desc_link {
                  font-size: 14px;
                  font-weight: 400;
                  color: #555666;
                  overflow: hidden;
                  white-space: normal;
                  word-break: break-word;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  text-align: left;
                }

                .desc_operation {
                  display: flex;
                  align-items: center;
                  margin-top: 14px;

                  .desc_operation_item {
                    display: inline-block;
                    vertical-align: top;
                    margin-right: 10px;
                  }
                }
              }

              .item_desc_icon {
                margin-right: 16px;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: start;
                -ms-flex-align: start;
                align-items: flex-start;
                padding-top: 2px;
                cursor: pointer;

                .desc_icon {
                  position: relative;
                  border-radius: 2px;
                  width: 134px;
                  height: 84px;
                  display: inline-block;
                  border: 1px solid #f5f6f7;
                  overflow: hidden;
                  background: #f5f6f7 50%;

                  .err_icon {
                    width: 100%;
                    height: 100%;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

	&.responsive_page {
		.content_area {
			width: 100%;
			:deep(.desc_operation) {
				display: block !important;

				.desc_operation_item {
					display: block !important;
					margin: 0 !important;
					padding: 5px 0;
				}
			}
		}
	}
}
</style>